<template>
    <div class="video-details-container mainContainer pbottom50">
        <div class="w11">
            <!-- 面包屑 -->
            <bread-crumb firstPath="/pcViews/learn" firstNav="在线学习" secondPath="/pcViews/learn/university" secondNav="老年大学" :breadcrumbText="courseName"></bread-crumb>
            <!-- 课程信息模块 -->
            <course-module>
                <!-- 课程基本信息开始 -->
                <course-content :isPurchase="isPurchase">
                    <div class="course-video" slot="course-video" v-if="isPurchase">
                        <vue-core-video-player src="https://media.vued.vanthink.cn/sparkle_your_name_am360p.mp4"></vue-core-video-player>
                    </div>
                    <div class="purchaseTipsBox" slot="purchaseTipsBox" v-if="!isPurchase">
                        <purchase-tips >
                            <span @click="purchase" slot="purchase"> 立即购买 </span>
                        </purchase-tips>
                    </div>
                    <p slot="course-purchase-num">1254</p>
                    <p slot="course-purchase-hour">125</p>
                    <div class="course_title" slot="course_title">
                        {{courseName}}
                    </div>
                    <h4 slot="real_price">53.0元</h4>
                    <div class="course_lecturer_list" slot="course_lecturer_list">
                        <span> 王二小 </span>
                        <span> 王二小 </span>
                    </div>
                    <span slot="startTime">2022-09-01 00:00:00</span>
                    <span slot="endTime">2022-10-31 23:59:59</span>
                    <div class="payBigBtn" @click="purchase" slot="payBigBtn">立即购买</div>
                    <div class="course_chapter_item" :class="{'active': chapterIdx == i}" slot="course_chapter_item" v-for="i in 4" :key="i" @click="changeChapter(i)">
                        <div class="chapter_title">
                            <p>录播</p>
                            <div>牛逼2156615665415641撒打发是.</div>
                        </div>
                        <div class="time">
                            40分钟
                        </div>
                    </div>
                </course-content>
                <!-- 课程基本信息结束 -->
                <!-- 课程相关信息开始 -->
                <course-correlation-info>
                    <!-- 选项卡开始 -->
                    <div class="course_info_tabs" slot="course_info_tabs">
                        <el-tabs v-model="tabsName" @tab-click="handleTabsClick">
                            <el-tab-pane label="课程详情" name="0"></el-tab-pane>
                            <el-tab-pane label="课程大纲" name="1"></el-tab-pane>
                            <el-tab-pane label="相关资料" name="2"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <!-- 选项卡结束 -->
                    <!-- 讲师介绍开始 -->
                    <course-correlation-info-title slot="lecturers_introduce_title">
                        <img src="~assets/images/learn/titleImg1.png" alt="" slot="img">
                        <p class="textColor1" slot="text">讲师介绍</p>
                    </course-correlation-info-title>
                    <i class="el-icon-arrow-left" slot="el-icon-arrow-left"></i>
                    <i class="el-icon-arrow-right" slot="el-icon-arrow-right"></i>
                    <swiper
                        ref="mySwiper"
                        :options="swiperOption"
                        class="swiper-no-swiping"
                        slot="lecturers_swiper"
                    >
                        <swiper-slide v-for="i in 6" :key="i">
                            <div class="swiperContent">
                                <img
                                    src="~assets/images/temporary/lecturerImg1.png"
                                    alt=""
                                    class="lecturerImg"
                                />
                                <div class="content">
                                    <p class="ellipsis">王晓鸥</p>
                                    <div>
                                        <p>简介：</p>
                                        <span>
                                            自2011年开始在中国
                                            建筑工业出版社出版
                                            注册结构师考试辅导
                                            书。认真、负责，是
                                            我的一贯作风。
                                        </span>

                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <!-- 讲师介绍结束 -->
                    <!-- 课程介绍开始 -->
                    <course-correlation-info-title slot="course_introduce_title">
                        <img src="~assets/images/learn/titleImg2.png" alt="" slot="img">
                        <p class="textColor2" slot="text">课程介绍</p>
                    </course-correlation-info-title>
                    <div class="course_introduce_text" slot="course_introduce_text">
                        Python包含的内容很多，加上各种标准库、拓展库，乱花渐欲迷人眼。我一直希望写一个快速的、容易上手的Python教程，而且言语简洁，循序渐进，让没有背
                        景的读者也可以从基础开始学习。我将在每一篇中专注于一个小的概念，希望在闲暇时可以很快读完。
                    </div>
                    <!-- 课程介绍结束 -->
                    <!-- 课程大纲开始 -->
                    <course-correlation-info-title slot="course_chapter_title">
                        <img src="~assets/images/learn/titleImg3.png" alt="" slot="img">
                        <p class="textColor3" slot="text">课程大纲</p>
                    </course-correlation-info-title>
                    <div class="course_chapter_list" slot="course_chapter_list">
                        <div class="course_chapter_item" v-for="i in 6" :key="i">
                            <div class="course_chapter_item_title">
                                <img src="~assets/images/learn/chapterVideoImg.png" class="chapterVideoImg" alt="" />
                                <div class="course_chapter_item_title_text">
                                【录播】21监理《建设工程目标控制（土建）》
                                </div>
                            </div>
                            <p class="course_chapter_duration">
                                视频时长：40分钟
                            </p>
                        </div>
                    </div>
                    <!-- 课程大纲结束 -->
                    <!-- 相关资料开始 -->
                    <course-correlation-info-title slot="course_file_title">
                        <img src="~assets/images/learn/titleImg4.png" alt="" slot="img">
                        <p class="textColor4" slot="text">相关资料</p>
                    </course-correlation-info-title>
                    <div class="course_file_list" slot="course_file_list">
                        <div class="course_file_item" v-for="i in 6" :key="i">
                            <img src="~assets/images/learn/checkImg.png" class="course_file_checkImg" alt="" v-if="(i%2) == 0">
                            <img src="~assets/images/learn/checkImga.png" class="course_file_checkImg" alt=""  v-else>
                            <div class="course_file_item_text" v-if="(i%2) == 0">分公司都i分工就是的风格</div>
                            <div class="course_file_item_text"  v-else style="color:#3aa8f4">老牛逼流口水的分级管理会计士大夫立刻给</div>
                        </div>
                        <div class="course_file_download">下载</div>
                    </div>
                    <!-- 相关资料结束 -->
                </course-correlation-info>
                <!-- 课程相关信息结束 -->
            </course-module>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import BreadCrumb from "components/contents/breadCrumb/BreadCrumb"
import CourseModule from "components/contents/courseModule/CourseModule"
import CourseCorrelationInfo from "components/contents/courseCorrelationInfo/CourseCorrelationInfo"
import CourseContent from "components/common/courseContent/CourseContent"
import PurchaseTips from "components/common/purchaseTips/PurchaseTips";
import CourseCorrelationInfoTitle from "components/common/courseCorrelationInfoTitle/CourseCorrelationInfoTitle";

export default {
    components:{ swiper, swiperSlide, BreadCrumb, CourseModule, CourseCorrelationInfo, CourseContent, PurchaseTips, CourseCorrelationInfoTitle },
    data(){
        let vue = this;
        return{
            swiperOption: {
                navigation: {
                    nextEl: ".el-icon-arrow-right",
                    prevEl: ".el-icon-arrow-left",
                },
                slidesPerView: 3,
                spaceBetween: 20,
                on: {
                    slideChange: function () {
                        vue.activeId = this.activeIndex;
                    },
                },
            },
            //是否已购买
            isPurchase:true,
            //章节下标
            chapterIdx:1,
            //选项卡标识
            tabsName:'',
            courseName:"2022年度内蒙古自治区专业技术人员继续教育（建筑类）专业课"
        }
    },
    methods:{
        //相关信息tabs切换
        handleTabsClick(tab){
            console.log(tab.name);
        },
        //购买课程
        purchase(){
            console.log("购买课程");
        },
        //切换章节
        changeChapter(index){
            this.chapterIdx = index;
        },
    }
}
</script>

<style lang="less" scoped>
.swiperContent{
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow: hidden;
    >.lecturerImg{
        width: 168px;
        height: 100%;
    }
    >.content{
        min-width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 12px;
        height: 100%;
        font-size: 14px;
        color: #000;
        line-height: 24px;
        font-family: "微软雅黑";
        >p{
            line-height: 48px;
            height: 48px;
            font-weight: bold;
        }
        >div{
            p{
                margin: 6px 0
            }
            span{
                max-height: 120px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5;
                overflow: hidden;
            }
        }
    }
}
.video-details-container{
    background: #f8f9fd;
}
</style>
